import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  facility: {
    "&.MuiListItem-root": {
      minHeight: 44,
      height: 44
    },
    "& .MuiListItemIcon-root": {
      minWidth: 42
    }
  },
  disabled: {
    opacity: 0.2,
    pointerEvents: "none"
  }
}));
